// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const buttonSizeVariants = {
    small: {
        height: 28,
        fontSize: 11,
        padding: "0 23px",
        icon: 10,
        iconPadding: 8,
    },
    medium: {
        height: 33,
        fontSize: 12,
        padding: "0 27px",
        icon: 12,
        iconPadding: 8,
    },
    large: {
        height: 42,
        fontSize: 14,
        padding: "0 23px",
        icon: 16,
        iconPadding: 8,
    },
};

export default buttonSizeVariants;
